import {useEffect, useState} from "react";
import Blocks from "../blocks";
import {useHistory, useParams} from "react-router-dom";
import {useMutation} from "react-query";
import {Dialog} from "@headlessui/react";
import SignupBg from "../../assets/images/study-signup.svg";
import {Field, Formik} from "formik";
import UTILS from "../../utils";
import Fields from "../formFields";
import Partials from "../partials";
import {useKeycloak} from "@react-keycloak/web";
import moment from "moment";
import {countryData} from '../../data/country';
import {updateTeacherProfile} from "../../api/user";
import {countryDataWithCode} from "../../data/countryCodes";

const PageTeacherCompleteProfile = () => {
    const history = useHistory();
    const {sid} = useParams();
    const {keycloak} = useKeycloak();


    const TeacherSid = keycloak?.idTokenParsed;
    useEffect(() => {
        const data = sessionStorage.getItem("teacherInfo");

    }, []);

    const [isDialogOpen, _setIsDialogOpen] = useState(false);
    const [fields, updateFields] = useState({password: true, passwordConfirmation: true});
    const toggle = (inputName) => {
        updateFields({
            ...fields,
            [inputName]: !fields[inputName]
        });
    }
    const [initialValues, _setInitialValues] = useState({
        email: '',
        password: '',
        passwordConfirmation: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        photo: '',
        dob: '',
        countryOptions: [],
        stateOptions: [],
        cityOptions: [],
        countryCode: "",
        countryDial: '',

    });

    const setCountry = (country) => {
        const countryObj = country ? {value: country, label: country} : {
            value: "",
            label: ""
        }
        return countryObj;
    }

    const setState = (state) => {
        const stateObj = state ? {value: state, label: state} : {
            value: "",
            label: ""
        }
        return stateObj;
    }

    const setCity = (city) => {
        const cityObj = city ? {value: city, label: city} : {
            value: "",
            label: ""
        }
        return cityObj;
    }

    const setGender = (gender) => {
        const genderObj = gender ? {value: gender, label: gender} : {
            value: "Male",
            label: "Male"
        }
        return genderObj;
    }
    const setDateOfBirth = (dob) => {
        const DOB = dob ? moment(dob).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        return DOB;
    }


    useEffect(() => {

        const teacherData = JSON.parse(sessionStorage.getItem("teacherInfo"));

        let countryCode = {code: 'IN'};
        const defaultCode = teacherData?.mobile_number.split("-");
        if (defaultCode?.length > 0) {
            countryCode = countryDataWithCode.find((item) => item.dial_code === `${defaultCode[0]}`);
        }


        const newInitValues = {
            id: teacherData?.id,
            email: teacherData?.email,
            first_name: teacherData?.first_name,
            last_name: teacherData?.last_name,
            mobile_number: teacherData?.mobile_number,
            photo: "",
            country: setCountry(teacherData?.country),
            state: setState(teacherData?.state),
            city: setCity(teacherData?.city),
            dob: setDateOfBirth(teacherData?.dob),
            gender: setGender(teacherData?.gender),
            countryCode: countryCode ? countryCode?.code : "IN",
            stateOptions: [],
            cityOptions: [],
        }

        _setInitialValues({...initialValues, ...newInitValues});

    }, []);


    const {isLoading, error, isError, mutate, data} = useMutation(updateTeacherProfile, {
        onSuccess: (data) => {
            history.push("/teacher/home");
        },
        onError: (err) => {
            console.log(err);
        },
    });

    const completeTeacherProfile = (values, action) => {

        const teacherData = keycloak?.idTokenParsed;

        const {
            first_name,
            last_name,
            photo,
            country,
            state,
            city,
            dob,
            gender,
            countryDial,
            mobile_number,
            password,
        } = values;
        const updatedPhoto = photo.replace("data:", "").replace(/^.+,/, "");
        const countryValue = country?.value;
        const stateValue = state?.value;
        const cityValue = city?.value;

        let mobileNo = ''
        if (countryDial && mobile_number) {
            mobileNo = `+${countryDial}-${mobile_number?.slice(values?.countryDial?.length)}`;
        }


        const dobValue = UTILS.time.getTimeStamp(dob);

        let teacher_obj = {
            id: values?.id,
            data: {
                id: values?.id,
                first_name,
                last_name,
                mobile_number: mobileNo ? mobileNo : values?.mobile_number,
                dob: dobValue,
                country: countryValue,
                state: stateValue,
                city: cityValue,
                gender: gender?.value,
                password,
            },
        }


        if (teacherData?.photo !== updatedPhoto) {
            const newTeacher_obj = {
                ...teacher_obj,
                data: {
                    ...teacher_obj?.data,
                    photo: updatedPhoto,
                }
            }
            mutate(newTeacher_obj);
        } else {
            mutate(teacher_obj);
        }
    }

    const handleCountryChangeFunc = (e, values) => {

        if (e.states?.length > 0) {
            const reInitialize = {
                country: {value: e?.value, label: e?.label},
                state: {label: "", value: ""},
                city: {label: "", value: ""},
                stateOptions: e?.states ? e?.states : [],
                cityOptions: [],
                mobile_number: values?.mobile_number,
                countryCode: values?.countryCode,
                countryDial: values?.countryDial,
            }
            _setInitialValues({...values, ...reInitialize});
        } else {
            const reInitialize = {
                country: {value: e?.value, label: e?.label},
                state: {label: "", value: ""},
                city: {label: "", value: ""},
                stateOptions: [],
                cityOptions: [],
                mobile_number: values?.mobile_number,
                countryCode: values?.countryCode,
                countryDial: values?.countryDial
            }
            _setInitialValues({...values, ...reInitialize});
        }
    }

    const handleStateChangeFunc = (e, values) => {

        if (e.cities?.length > 0) {
            const reInitialize = {
                state: {value: e?.value, label: e?.label},
                city: {value: "", label: ""},
                cityOptions: e?.cities ? e?.cities : []
            }
            _setInitialValues({...initialValues, ...reInitialize});
        } else {
            const reInitialize = {
                state: {value: e.value, label: e.label},
                city: {value: "", label: ""},
                cityOptions: []
            }
            _setInitialValues({...values, ...reInitialize});
        }
    }
    return (
        <div className={'page PageStudentCompleteProfile'}>
            <div className="container mx-auto">
                <h3 className={"block md:hidden text-xl text-center pt-16 pb-4 font-['Poppins-Bold']"}>{`Complete Teacher's profile`}</h3>
                <div className="relative flex flex-col md:flex-row items-center">
                    <Dialog
                        open={isDialogOpen}
                        onClose={() => _setIsDialogOpen(false)}
                        className="absolute w-80 h-96 z-10 right-1/2 bottom-1/2 translate-x-2/4 translate-y-2/4 border-2 border-b-blue-800"
                    >
                        <Dialog.Overlay/>
                        <Dialog.Title>Camera</Dialog.Title>
                        <Dialog.Description>

                        </Dialog.Description>
                        <button onClick={() => _setIsDialogOpen(false)}>Capture</button>
                    </Dialog>
                    <div className="bgWrapper md:flex justify-center items-center bg-white">
                        <img src={SignupBg} alt="" draggable={false}/>
                    </div>
                    <div
                        className="pageContent w-full max-w-lg mx-auto md:mr-0 md:ml-auto mt-4 md:mt-0  mb-4 bg-white p-4 rounded-xl">
                        <h4 className={'hidden md:block text-2xl font-subheading'}>{`Complete Teacher's profile`}</h4>
                        <Blocks.ErrorBoundary>
                            <Formik
                                enableReinitialize={true}
                                initialValues={initialValues}
                                validationSchema={UTILS.forms.TeacherCompleteProfile}
                                onSubmit={completeTeacherProfile}

                            >
                                {({
                                      setFieldValue,
                                      handleSubmit,
                                      isSubmitting,
                                      values,
                                  }) => (

                                    <form onSubmit={handleSubmit} className="pt-6 pb-8">
                                        <div className="md:grid md:grid-cols-2 gap-4">
                                            <Field type={'text'} name="first_name" placeholder="First Name"
                                                   iconBefore={<i className={`text-xl icon icon-user`}></i>}
                                                   component={Fields.FieldInput}/>
                                            <Field type='text' name="last_name" placeholder="Last Name"
                                                   iconBefore={<i className={`text-xl icon icon-user`}></i>}
                                                   component={Fields.FieldInput}/>
                                        </div>
                                        <div className="md:grid md:grid-cols-2 gap-4">
                                            <Field type='email'
                                                   name="email"
                                                   placeholder="Email Id"
                                                   iconBefore={<i className={`text-xl icon icon-mail1`}></i>}
                                                   component={Fields.FieldInput}
                                                   disabled={true}
                                            />
                                            <Field
                                                type='text'
                                                name="mobile_number"
                                                placeholder="Mobile number"
                                                iconBefore={<i className={`text-xl icon icon-phone`}></i>}
                                                component={Fields.FieldInputPhoneNumber}
                                            />
                                        </div>
                                        <div className="md:grid md:grid-cols-2 gap-4">
                                            <Field
                                                type='date'
                                                name="dob" placeholder="Date of Birth"
                                                iconBefore={<span className="italic font-bold">DOB</span>}
                                                max={moment().subtract(4, 'year').format('YYYY-MM-DD')}
                                                component={Fields.FieldInput}/>
                                            <Field name="gender"
                                                   options={[
                                                       {value: "male", label: "Male"},
                                                       {value: "female", label: "Female"},
                                                   ]}
                                                   component={Fields.FieldSelect}
                                            />
                                        </div>
                                        <div className="md:grid md:grid-cols-2 gap-4">
                                            <Field type={fields.password ? 'password' : 'text'} name="password"
                                                   placeholder="Password"
                                                   iconBefore={<i className={`text-xl icon icon-unlock`}></i>}
                                                   iconAfter={
                                                       <i className={`text-xl cursor-pointer icon icon-${fields.password ? 'eye-off' : 'eye'}`}
                                                          onClick={() => toggle('password')}></i>}
                                                   component={Fields.FieldInput}/>
                                            <Field type={fields.passwordConfirmation ? 'password' : 'text'}
                                                   name="passwordConfirmation" placeholder="Re-type Password"
                                                   iconBefore={<i className={`text-xl icon icon-unlock`}></i>}
                                                   iconAfter={
                                                       <i className={`text-xl icon cursor-pointer icon-${fields.passwordConfirmation ? 'eye-off' : 'eye'}`}
                                                          onClick={() => toggle('passwordConfirmation')}></i>}
                                                   component={Fields.FieldInput}/>
                                        </div>
                                        <Field type='text' name="country" placeholder="Country"
                                               iconBefore={<span className="italic font-bold">Country</span>}
                                               options={countryData?.countries}
                                               component={Fields.FieldSelect}
                                               onChange={(e) => {
                                                   setFieldValue("stateOptions", e.states);
                                                   handleCountryChangeFunc(e, values);
                                               }}
                                        />
                                        <Field type='text' name="state" placeholder="state"
                                               options={values?.stateOptions}
                                               iconBefore={<span className="italic font-bold">State</span>}
                                               component={Fields.FieldSelect}
                                               onChange={(e) => {
                                                   setFieldValue("cityOptions", e.cities);
                                                   handleStateChangeFunc(e, values);
                                               }}
                                        />
                                        <Field type='text' name="city" placeholder="City"
                                               iconBefore={<span className="italic font-bold">City</span>}
                                               options={values?.cityOptions}
                                               component={Fields.FieldSelectCity}
                                        />

                                        <Field name={"photo"}
                                               component={Fields.FieldCameraInput}/>
                                        <button
                                            onClick={() => handleSubmit()}
                                            disabled={isLoading}
                                            className="bg-black w-full hover:bg-zinc-700 text-white inline-flex justify-center font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline transition ease-in-out duration-150"
                                            type="submit">
                                            {isLoading &&
                                                <Partials.PartialLoading/>
                                            }
                                            Save changes
                                        </button>
                                    </form>
                                )}
                            </Formik>
                        </Blocks.ErrorBoundary>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageTeacherCompleteProfile;
